import { Registration } from '@pages/Registration/Registration.main';

export { Registration };
